import { OpportunityActivities } from './DTO/opportunityViewResponseDTO';
import { ActivityType } from './enums/activityType';
import { ProspectMinimal } from './prospectMinimal';

export enum EventOutcome {
  Scheduled = 'Scheduled',
  Completed = 'Completed',
  Rescheduled = 'Rescheduled',
  NoShow = 'NoShow',
  Canceled = 'Canceled',
}

export interface MeetingActivity {
  id: number;
  provider: 'Google' | 'Outlook';
  title: string | null;
  startTime: string;
  endTime: string | null;
  isAllDay: boolean;
  location: string | null;
  description: string | null;
  htmlLink: string | null;
  conferenceLink: string | null;
  organizerEmail: string | null;
  attendeeEmails: string[] | null;
  conferencePhoneNumber: string | null;
  conferencePhonePin: string | null;
  calendarId: string | null;
}

export interface Event {
  id: number;
  userId: number;
  owned: boolean;
  user?: string | null;
  objectId: string;
  accountId: string | null;
  prospectId: string | null;
  whoId: string;
  whatId: string | null;
  activityDateTime: string;
  subject: string;
  eventSubtype: string;
  prospect?: ProspectMinimal;

  opportunityId: string | null;
  ownerId: string | null;
  createdDate: string;
  lastModifiedDate: string;
  account: {
    objectId: string | null;
    name: string | null;
  } | null;
  opportunity: OpportunityActivities | null;
  meeting?: MeetingActivity | null;
  endDateTime: string | null;
  isAllDayEvent: boolean | null;
  description: string | null;
  conferenceLink: string | null;
  location: string | null;
  attendeeEmails: string[] | null;
  prospects: ProspectMinimal[] | null;
  type: ActivityType;
  isSynced: boolean | null;
  outcome: EventOutcome | null;
}

export function isEvent(object: unknown): object is Event {
  return !!object && typeof object === 'object' && 'eventSubtype' in object;
}

export function isMeetingEvent(object: unknown): object is Event {
  return (
    isEvent(object) &&
    (object.type === ActivityType.MEETING || object.eventSubtype === 'Meeting')
  );
}
